import { ServiceMetadataStore } from "@infrastructure/stores/serviceMetadata.store";
import { apiClients } from "@infrastructure/clients";
import { catchError } from "@shared/utils/errors/catchError";

class ServiceMetadataServiceClass {
  private _loaded = false;
  private _loadPromise: Promise<void> | null = null;

  getStore() {
    return ServiceMetadataStore;
  }

  async loadServices(): Promise<void> {
    if (this._loaded) return;
    if (this._loadPromise) return this._loadPromise;

    this._loadPromise = this._fetch();
    await this._loadPromise;
    this._loadPromise = null;
  }

  private async _fetch(): Promise<void> {
    const [error, result] = await catchError(
      apiClients.http.service.getServices()
    );
    if (error) {
      console.error("[ServiceMetadataService] Failed to load services:", error);
      return;
    }
    ServiceMetadataStore.setServices(result.data.services);
    this._loaded = true;

    const parentsWithVariants = result.data.services
      .filter((s) => s.has_variants)
      .map((s) => s.service_type);
    for (const parent of parentsWithVariants) {
      await this.loadVariants(parent);
    }
  }

  async loadVariants(parentServiceType: string): Promise<string[]> {
    const [error, result] = await catchError(
      apiClients.http.service.getServiceVariants(parentServiceType)
    );
    if (error) {
      console.error("[ServiceMetadataService] Failed to load variants:", error);
      return [];
    }
    ServiceMetadataStore.addVariants(result.data.services);
    return result.data.services.map((s) => s.service_type);
  }
}

export const ServiceMetadataService = new ServiceMetadataServiceClass();
